(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const announcementBar = document.querySelector('.utility-bar');

    if (announcementBar) {
      document.documentElement.style.setProperty('--announcement-height', `${announcementBar.offsetHeight}px`);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Runs for every sticky_header_type (the StickyHeader element below only
  // exists when stickiness is enabled), so header metrics are always set.
  (function () {
    const header = document.querySelector('.section-header');
    if (!header) return;

    function updateHeaderMetrics() {
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);

      // The mega-menu panel is position:absolute inside the (not full-width)
      // .header__inline-menu, so it tracks the header's bottom via top:100%
      // with no scroll handler. These offsets pull its background out to the
      // viewport edges for full bleed; they only change on layout, not scroll.
      const nav = header.querySelector('.header__inline-menu');
      if (nav) {
        const rect = nav.getBoundingClientRect();
        header.style.setProperty('--mega-menu-bleed-left', `${rect.left}px`);
        header.style.setProperty('--mega-menu-bleed-right', `${window.innerWidth - rect.right}px`);
      }
    }

    updateHeaderMetrics();
    document.addEventListener('DOMContentLoaded', updateHeaderMetrics);
    window.addEventListener('load', updateHeaderMetrics);
    window.addEventListener('resize', updateHeaderMetrics);
  })();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      // Equalize mega-menu heights to the tallest one. Wait for window load
      // (not connectedCallback / DOMContentLoaded) so images inside each
      // menu have finished loading — otherwise their intrinsic heights
      // aren't reflected in offsetHeight and one of the menus can read as
      // unexpectedly large or small, breaking the equalization. Re-measure
      // on resize since natural heights depend on viewport width.
      this.onResizeHandler = this.equalizeMegaMenuHeights.bind(this);
      if (document.readyState === 'complete') {
        this.equalizeMegaMenuHeights();
      } else {
        window.addEventListener('load', this.onResizeHandler, { once: true });
      }
      window.addEventListener('resize', this.onResizeHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    equalizeMegaMenuHeights() {
      const detailsList = this.header.querySelectorAll('details.mega-menu');
      if (detailsList.length === 0) return;

      // Clear any previously-set value so we measure each element's natural
      // size, not the equalized one from the last run.
      this.header.style.removeProperty('--mega-menu-min-height');

      // Each mega menu lives inside a <details>. A closed <details> lays
      // its content out differently than an open one (the user reported
      // 770px closed vs 515px open). To get the *real* open height, we
      // temporarily open each one — hidden via visibility so the user
      // doesn't see a flash — measure, then restore.
      let maxHeight = 0;
      detailsList.forEach((details) => {
        const wasOpen = details.hasAttribute('open');
        const previousVisibility = details.style.visibility;

        if (!wasOpen) {
          details.style.visibility = 'hidden';
          details.setAttribute('open', '');
        }

        const content = details.querySelector('.mega-menu__content');
        if (content && content.offsetHeight > maxHeight) {
          maxHeight = content.offsetHeight;
        }

        if (!wasOpen) {
          details.removeAttribute('open');
          details.style.visibility = previousVisibility;
        }
      });

      // Exposed as a CSS variable so the matching rule in
      // component-mega-menu.css can scope it to the sticky state only.
      this.header.style.setProperty('--mega-menu-min-height', `${maxHeight}px`);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      const disclosures = this.header.querySelectorAll('header-menu');

      disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') {
          disclosure.close();
        }
      });
    }

    closeSearchModal() {
      const searchModal = this.header.querySelector('details-modal');

      if (searchModal?.close) {
        searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
